import { GlobalAxios } from "../axios/axios-config";
import { ICalendarPreference } from "../models/calendar-preference";

const CALENDAR_REFERENCE_ROUTE =
  process.env.REACT_APP_CALENDAR + "/api/v1/CalendarPreference";

export const calendarPreferenceList = (params?: any) => {
  return GlobalAxios.get<ICalendarPreference[]>(CALENDAR_REFERENCE_ROUTE, {
    params: params,
    paramsSerializer: { indexes: null },
  });
};
